import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'
import Welcome from '../components/Welcome.vue'
import MemberList from '../components/member/MemberList.vue'
import AdminList from '../components/admin/AdminList.vue'
import RightList from '../components/right/RightList.vue'
import RoleList from '../components/role/RoleList.vue'
import CategoryGroupList from '../components/category_group/GroupList.vue'
import SpeakerList from '../components/speaker/SpeakerList.vue'
import CategoryList from '../components/category_group/CategoryList.vue'
import ContentList from '../components/content/contentList.vue'
import CarouselList from '../components/carousel/CarouselList.vue'
import ConfigList from '../components/config/ConfigList.vue'
import LectionDayList from '../components/lection_day/LectionDayList.vue'
import ArticleDomainList from '../components/article_domain/ArticleDomainList.vue'
import ArticleList from '../components/article/ArticleList.vue'
import ArticleCategoryList from '../components/article/ArticleCategoryList.vue'
import PracticeDayList from '../components/practice_day/PracticeDayList.vue'
import ConfigLinkList from '../components/config_link/configLinkList.vue'
import OtherPicOuterList from '../components/other/PicOuterList.vue'
import ConfigBibleList from '../components/config_bible/configBibleList.vue'
import LightReadingDailyList from '../components/light_reading_daily/LightReadingDailyList.vue'
import handpickGroupList from '../components/handpick_group/handpickGroupList.vue'
import handpickSourceList from '../components/handpick_source/handpickSourceList.vue'
import handppickSourceHitList from '../components/handpick_source/handpickSourceHitList.vue'
import handpickAuthorList from '../components/handpick_author/handpickAuthorList.vue'
import handpickCategoryList from '../components/handpick_category/handpickCategoryList.vue'
import handpickArticleListVue from '../components/handpick_article/handpickArticleList.vue'
import handpickSourceArticleList from '../components/handpick_source/handpickSourceArticleList.vue'
import DeepSeekChatList from '../components/deep_seek/chatList'
import FeedbackList from '../components/feedback/FeedbackList.vue'
// import TinymceEditor from '../components/editor/tinymce.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome },
      { path: '/member/list', component: MemberList },
      { path: '/admin/list', component: AdminList },
      { path: '/right/list', component: RightList },
      { path: '/role/list', component: RoleList },
      { path: '/category_group/list', component: CategoryGroupList },
      { path: '/speaker/list', component: SpeakerList },
      { path: '/category/list', component: CategoryList },
      { path: '/content/list', component: ContentList },
      { path: '/carousel/list', component: CarouselList },
      { path: '/config/list', component: ConfigList },
      { path: '/lection_day/list', component: LectionDayList },
      { path: '/article_domain/list', component: ArticleDomainList },
      { path: '/article/list', component: ArticleList },
      { path: '/article_category/list', component: ArticleCategoryList },
      { path: '/practice_day/list', component: PracticeDayList },
      { path: '/config_link/list', component: ConfigLinkList },
      { path: '/other/pic_outer', component: OtherPicOuterList },
      { path: '/config_bible/list', component: ConfigBibleList },
      { path: '/light_reading/daily_list', component: LightReadingDailyList },
      { path: '/handpick/group_list', component: handpickGroupList },
      { path: '/handpick/source_list', component: handpickSourceList },
      { path: '/handpick/source_list_hit', component: handppickSourceHitList },
      { path: '/handpick/author_list', component: handpickAuthorList },
      { path: '/handpick/category_list', component: handpickCategoryList },
      { path: '/handpick/article_list', component: handpickArticleListVue },
      { path: '/handpick/source_article_list', component: handpickSourceArticleList },
      { path: '/deep_seek/chat_list', component: DeepSeekChatList },
      { path: '/feedback/list', component: FeedbackList }
      // { path: '/editor/tinymce', component: TinymceEditor }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.query.qt !== undefined) {
    window.sessionStorage.setItem('token', to.query.qt)
    return next('/home')
  }
  if (to.path === '/login') return next()
  const token = window.sessionStorage.getItem('token')
  if (!token) return next('/login')
  next()
})

export default router
